/**
 * FIOR Mobile Spacing Override v1.0
 * Riduce lo spacing tra sezioni homepage solo su mobile (<990px)
 * Sovrascrive inline styles generati da Shopify Berlin theme
 */

(function() {
  'use strict';
  
  // ========================================
  // CONFIGURAZIONE SPACING (modifica qui)
  // ========================================
  const spacingConfig = {
    'image_banner_jxHFXz': { 
      top: 0,      // Hero - no padding top
      bottom: 0   // 16px bottom
    },
    'multicolumn': { 
      top: 16,     // 16px top
      bottom: 20   // 20px bottom (totale gap: 36px)
    },
    'products_grid_6p4MX7': { 
      top: 20,     // 20px top
      bottom: 20   // 20px bottom (totale gap: 40px)
    },
    'image-tabs': { 
      top: 20,     // 20px top
      bottom: 20   // 20px bottom (totale gap: 40px)
    },
    'instagram-collage': { 
      top: 20,     // 20px top
      bottom: 16   // 16px bottom (totale gap: 36px)
    },
    'faq_qUBzxz': { 
      top: 16,     // 16px top
      bottom: 12   // 12px bottom (totale gap: 28px)
    },
    'testimonials_PUE4bK': { 
      top: 12,     // 12px top
      bottom: 20   // 20px bottom (totale gap: 32px)
    },
    'newsletter_VBq4dP': { 
      top: 20,     // 20px top
      bottom: 0    // 0px bottom - fine pagina
    }
  };
  
  // Breakpoint mobile (Berlin theme standard)
  const MOBILE_BREAKPOINT = 990;
  
  // ========================================
  // FUNZIONE PRINCIPALE
  // ========================================
  function applyMobileSpacing() {
    // Verifica se siamo su mobile
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      return; // Desktop - non fare nulla
    }
    
    // Log per debug (rimuovi in produzione)
    console.log('🎨 FIOR: Applicando spacing mobile...');
    
    let sectionsFound = 0;
    
    // Loop attraverso ogni sezione configurata
    Object.keys(spacingConfig).forEach(sectionId => {
      const config = spacingConfig[sectionId];
      
      // Trova il container della sezione
      const sectionSelector = `#shopify-section-template--20369721065689__${sectionId}`;
      const section = document.querySelector(sectionSelector);
      
      if (!section) {
        console.warn(`⚠️ FIOR: Sezione non trovata - ${sectionId}`);
        return;
      }
      
      // Trova il div con classe padding
      const paddingDiv = section.querySelector(`[class*="section-template"][class*="padding"]`);
      
      if (!paddingDiv) {
        console.warn(`⚠️ FIOR: Padding div non trovato in ${sectionId}`);
        return;
      }
      
      // Applica i nuovi valori
      paddingDiv.style.paddingTop = `${config.top}px`;
      paddingDiv.style.paddingBottom = `${config.bottom}px`;
      
      sectionsFound++;
      console.log(`✅ FIOR: Spacing applicato a ${sectionId} (${config.top}px / ${config.bottom}px)`);
    });
    
    console.log(`🎉 FIOR: Spacing mobile applicato a ${sectionsFound} sezioni`);
  }
  
  // ========================================
  // INIZIALIZZAZIONE
  // ========================================
  
  // Esegui al caricamento DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMobileSpacing);
  } else {
    // DOM già pronto
    applyMobileSpacing();
  }
  
  // Riesegui su resize (debounced per performance)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      applyMobileSpacing();
    }, 250);
  });
  
  // Supporto Theme Editor di Shopify
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(applyMobileSpacing, 100);
    });
  }
  
})();